import { FormControl, FormLabel, Select } from '@mui/material';

import SelectPlaceholder from '../selectPlaceholder';

export const EmptySelect = ({
  title,
  selectClass,
  size = 'small',
}: {
  title: string;
  selectClass?: string;
  size?: 'small' | 'medium';
}) => {
  return (
    <FormControl size='small' className='flex-1'>
      {title && <FormLabel>{title}</FormLabel>}
      <Select
        sx={size === 'medium' ? { height: '48px' } : {}}
        displayEmpty
        renderValue={() => <SelectPlaceholder />}
        disabled
        value=''
        className={selectClass}
      />
    </FormControl>
  );
};
